import React, { useContext, useEffect, useState } from "react";
import { Contexto } from "@Componentes/App";
import * as _api_ from "@Funciones/api";
import * as _f_ from "@Funciones/funciones";
import * as _ipt_ from "@Elementos/Input";
import * as _btn_ from "@Elementos/Boton";
import * as _anim_ from "@Elementos/Animaciones";
import * as _tabla_ from "@Elementos/Tabla";
import * as _form_ from "@Elementos/Formulario";
import * as _opt_ from "@Elementos/Opciones";
import Filtros from "@Composicion/Filtros/Filtros";
import ModalInformacion from "@ModalInformacion/ModalInformacion";
import * as _testing_ from "@Funciones/testing";

import * as ef from "./Elementos";
import * as e from "./FormularioCSS";

export function Formulario(param) {
  const { esComputadora, rol, usuariosesion, codRol } = useContext(Contexto);
  const [form, setform] = useState(null);
  const [id, setid] = useState(null);
  const [elementos, _] = useState({
    inputtext: ef.InputTextForm,
    inputnumber: ef.InputNumberForm,
    inputcamara: ef.InputCamaraBase64,
    checkbox: ef.CheckboxForm,
    radiobutton: ef.RadiobuttonForm,
    option: ef.OptionForm,
    date: ef.DateForm,
  });
  const [variables, setvariables] = useState({});
  const [variablesAnteriores, setVariablesAnteriores] = useState({});
  const [valorescampos, setvalorescampos] = useState({});
  const [eventoSucedido, setEventoSucedido] = useState("");
  const [variableEvento, setVariableEvento] = useState("");
  useEffect(() => {
    // console.log(param)
    //console.log("onBlurCampos" in param ? param.onBlurCampos["ndoc"]: ()=>{})
    // console.log(setDatosExternosForm)
    if ("dext" in param) {
      param.dext(() => setDatosExternosForm);
    }
  }, []);

  useEffect(() => {
    const inicio = async () => {
      if (param?.api !== undefined && param?.parametros !== undefined) {
        const crud = await _api_?.[param?.api](...param?.parametros, "Formulario.js");
        if (crud) {
          if (crud.SMListaErrores.length === 0) {
            setform(crud.form);
            setid(crud.id);
            crud.form.map((e) => {
              setvalorescampos((vc) => ({ ...vc, [e.conf.id]: e.data.valor }));
              setVariablesAnteriores(variables);
              setvariables((vc) => ({
                ...vc,
                [e.conf.className]: e.data.valor,
              }));
            });
          } else {
            // console.log(crud);
          }
        } else {
          // console.log(crud);
        }
      } else {
        if (param?.form) {
          setform(param?.form);
          setid(param?.id);
          param?.form.map((e) => {
            setvalorescampos((vc) => ({ ...vc, [e.conf.id]: e.data.valor }));
            setVariablesAnteriores(variables);
            setvariables((vc) => ({ ...vc, [e.conf.className]: e.data.valor }));
          });
        }
      }
    };
    inicio();
  }, [param?.form, param?.id]);

  useEffect(() => {
    param?.fObtenerDatosFormulario?.(variables);
  }, [variables]);

  const changeValue = (e) => {
    setvalorescampos((vc) => ({
      ...vc,
      [e.target.id]: ["checkbox"].includes(e.target.type) ? e.target.checked : e.target.value,
    }));
    setVariablesAnteriores(variables);
    setvariables((vc) => ({
      ...vc,
      [e.target.className]: ["checkbox"].includes(e.target.type) ? e.target.checked : e.target.value,
    }));
  };

  const clickBoton = (e, childOnClick) => {
    if (e.target.className.includes("aceptform")) {
      //boton aceptar
      childOnClick(variables);
    } else if (e.target.className.includes("cancelform")) {
      //boton cancelar
      childOnClick();
    } else if (e.target.className.includes("cleanform")) {
      //limpiar variables
      param?.form.map((e) => {
        setvalorescampos((vc) => ({ ...vc, [e.conf.id]: "" }));
        setVariablesAnteriores(variables);
        setvariables((vc) => ({ ...vc, [e.conf.className]: "" }));
      });
      childOnClick();
    } else if (e.target.className.includes("")) {
      childOnClick();
    }
  };

  const setDatosExternosForm = (clave, valor) => {
    // setVariablesAnteriores(variables);
    setvariables((prev) => ({
      ...prev,
      [clave]: valor,
    }));
  };

  useEffect(() => {}, []);

  return (
    <>
      {
        <e.Contenido $escomputadora={esComputadora}>
          {form !== null && (
            <div className="formulariotemplate">
              {param?.titulo !== undefined && <div className="tituloformtemplate">{param?.titulo}</div>}
              <div className="elementostemplate">
                {form !== null &&
                  form.map((f) => {
                    if (elementos[f.tipo]) {
                      const Elemento = elementos[f.tipo];
                      const vardependencia = f.data.variabledependencia;
                      const valdependencia = f.data.valordependencia;
                      const valexcluyente = f.data.valorexcluyente;
                      const varvisible = f.data.variablevisible;
                      const varEditarVisible = "varEditarVisible" in f.data ? f.data.varEditarVisible : 2;
                      return (
                        <Elemento
                          key={f.conf.id}
                          conf={f.conf}
                          data={f.data}
                          valorescampos={valorescampos}
                          variables={variables}
                          onChange={(evento) => {
                            changeValue?.(evento);
                            // setEventoSucedido("change");
                            // setVariableEvento(f.conf.className);
                            if ("onChangeCampos" in param && f.conf.className in param.onChangeCampos) {
                              if ("onChangeCampos" in param) {
                                param.onChangeCampos[f.conf.className](evento.target,variables,variablesAnteriores,f.conf.className);
                              }
                            }
                          }}
                          onBlur={
                            "onBlurCampos" in param && f.conf.className in param.onBlurCampos
                              ? (p1) => {
                                  changeValue(p1);
                                  param.onBlurCampos[f.conf.className](variables, variablesAnteriores,f.conf.className);
                                  setEventoSucedido("blur");
                                }
                              : () => {}
                          }
                          visible={f.visible}
                          vardependencia={vardependencia}
                          valdependencia={valdependencia}
                          valexcluyente={valexcluyente}
                          varvisible={varvisible}
                          varEditarVisible={varEditarVisible}
                        />
                      );
                    }
                  })}
              </div>
              {param?.opciones !== undefined && param?.opciones && (
                <div className="opcionestemplate">
                  {param.children ? (
                    React.Children.map(param.children, (child) => {
                      if (React.isValidElement(child)) {
                        return React.cloneElement(child, {
                          onClick: (e) => clickBoton(e, child.props.onClick),
                        });
                      }
                      return child;
                    })
                  ) : (
                    <div></div>
                  )}
                </div>
              )}
            </div>
          )}
        </e.Contenido>
      }
    </>
  );
}
